import { z } from 'zod';

const TipoItemCatalogoAcessoEnum = z.enum(['sistema_bidirecional', 'notificacao_unica', 'acesso_fisico']);

const ContextoAcessoEnum = z.enum(['admissao', 'desligamento']);

export const ConfigCatalogoAcessoSchema = z.object({
  id: z.string().min(1, 'O ID do item é obrigatório'),
  nome: z.string().min(1, 'O nome é obrigatório'),
  tipo: TipoItemCatalogoAcessoEnum,
  aplicavelEm: z.array(ContextoAcessoEnum).min(1, 'Selecione ao menos um contexto'),
  permiteNaoSeAplica: z.boolean(),
});

export const ConfigTipoEquipamentoSchema = z.object({
  id: z.string().min(1, 'O ID do tipo é obrigatório'),
  nome: z.string().min(1, 'O nome é obrigatório'),
  requerPatrimonio: z.boolean(),
  requerNumeroSerie: z.boolean(),
  requerInformativoProteja: z.boolean(),
});

export const ConfigTipoSolicitacaoSchema = z.object({
  id: z.string().min(1, 'O ID do tipo é obrigatório'),
  nome: z.string().min(1, 'O nome é obrigatório'),
  possuiBlocoAcessos: z.boolean(),
  geraMovimentacaoEnvio: z.boolean(),
  geraMovimentacaoDevolucao: z.boolean(),
});

export const ConfigRegrasClienteSchema = z.object({
  clienteId: z.string().min(1, 'O cliente é obrigatório'),
  etapasAdicionais: z.array(z.string()).optional(),
  etapasDispensadas: z.array(z.string()).optional(),
  permiteEquipamentoCliente: z.boolean().optional(),
  usaEquipamentoHomologado: z.boolean().optional(),
  nomeEmpresaProprietaria: z.string().optional(),
  cnpjEmpresaProprietaria: z.string().optional(),
});
